/**
 * API base URL for backend requests.
 * - In development: use empty string so /api/* is proxied by src/setupProxy.js to the Node server.
 * - In production: leave REACT_APP_API_BASE_URL unset for same-origin /api/* (GCP Nginx).
 */
export const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

/**
 * @deprecated Use API_BASE — sponsors and partners are proxied by the main backend (/api/sponsors, /api/lab/partners, etc.).
 */
export const UH_API_BASE = API_BASE;

/** Same as API_BASE; partner/sponsor reads go through main server proxies. */
export const PARTNERS_API_BASE = API_BASE;

/*
 * Ping the backend once to warm the API connection.
 * Call early (e.g. on app load) so later API calls are fast.
 */
export function wakeUpBackend() {
  const url = API_BASE ? `${API_BASE}/api/contact` : '/api/contact';
  fetch(url, { method: 'GET' }).catch(() => {});
}
